import Pikaday from "pikaday";
import Modernizr from "modernizr";
import "imports-loader?Modernizr=modernizr,MobileDetect=mobile-detect!mobile-detect/mobile-detect-modernizr";
import bowser from "bowser";
import {
    PikadayI18n
} from "general/VuePickadayDirective";

$(function () {
    const $fields = $('.js-field');

    $fields.each(function (i, el) {
        const $field = $fields.eq(i),
            $isMobile = Modernizr.inputtypes.date && Modernizr.mobile,
            $isEdge = Modernizr.inputtypes.date && !!bowser.msedge;

        if (!($isMobile || $isEdge) && $field.hasClass("js-pikaday")) {
            const $fieldInput = $field.find(".js-field__input");

            const mDate = moment($fieldInput.attr("value"), "DD.MM.YYYY");

            if (mDate.isValid()) {
                $fieldInput.val(mDate.format("YYYY-MM-DD"));
            };

            const pikadayInstance = new Pikaday({
                theme: "pika--quaternary",
                yearRange: [
                    moment().subtract(100, "years").year(),
                    moment().add(100, "years").year()
                ],
                defaultDate: mDate.isValid() ? mDate.toDate() : null,
                setDefaultDate: mDate.isValid(),
                minDate: moment().subtract(100, "years").toDate(),
                maxDate: moment().toDate(),
                i18n: PikadayI18n,
                onSelect: function () {
                    $fieldInput.val(this.getMoment().format("YYYY-MM-DD"));
                    $fieldInput.parsley().validate();

                    this.hide();
                    $fieldInput.blur();
                },
            });

            pikadayInstance.hide();
            $field.append(pikadayInstance.el);

            $fieldInput.on("focus", () => {
                pikadayInstance.show();
            });

            $fieldInput.on("input", (e) => {
                pikadayInstance.setDate(e.target.value, true);
            });

            $fieldInput.on("focusout", (e) => {                
                if (!$.contains(pikadayInstance.el, e.relatedTarget || e.target)) {
                    pikadayInstance.hide();
                }
            });

            try {
                document.removeEventListener("keydown", pikadayInstance._onKeyChange);
            } catch (err) {
                console.log(err);
            }
        }
    })
});



// WEBPACK FOOTER //
// ./static/components/Datepicker.js